module.exports = __webpack_public_path__ + "static/media/sample_lmroute_config.1eed8094.csv";